import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import { ScrollRestoration } from 'react-router-dom';

const Section = ({ title, children }) => (
  <div className="mb-10">
    <h2 className="text-xl font-bold text-gray-800 mb-3 border-l-4 border-red-600 pl-4">{title}</h2>
    <div className="text-gray-600 leading-relaxed space-y-2">{children}</div>
  </div>
);

function Gdpr() {
  return (
    <div>
      <Navbar />
      <div className="bg-gradient-to-br from-gray-900 to-gray-800 flex items-center min-h-[30vh] pt-24 pb-10">
        <div className="max-w-screen-xl mx-auto px-6 text-center w-full">
          <h1 className="text-white text-4xl md:text-5xl font-extrabold">
            Ochrana <span className="text-red-500">osobných údajov</span>
          </h1>
          <p className="text-gray-300 mt-3 text-base">Informácie podľa čl. 13 nariadenia GDPR</p>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-6 py-16">

        <Section title="1. Prevádzkovateľ osobných údajov">
          <p>
            <strong>Petromin, spol. s r.o.</strong><br />
            Prešovská 539, 087 01 Giraltovce<br />
            IČO: 31701591<br />
            Email: <a href="mailto:petromin@petromin.sk" className="text-red-600 hover:underline">petromin@petromin.sk</a><br />
            Tel.: <a href="tel:+421918495001" className="text-red-600 hover:underline">0918 495 001</a>
          </p>
        </Section>

        <Section title="2. Aké osobné údaje spracúvame">
          <p>V rámci kontaktného formulára a objednávkových formulárov na tejto webovej stránke spracúvame nasledujúce osobné údaje:</p>
          <ul className="list-disc list-inside space-y-1 mt-2">
            <li>Meno a priezvisko</li>
            <li>Emailová adresa</li>
            <li>Telefónne číslo</li>
            <li>Obsah správy alebo detaily objednávky (druh tovaru, množstvo, spôsob prevzatia)</li>
          </ul>
        </Section>

        <Section title="3. Účel a právny základ spracúvania">
          <p>Vaše osobné údaje spracúvame výlučne na účely:</p>
          <ul className="list-disc list-inside space-y-1 mt-2">
            <li><strong>Vybavenia dopytu / objednávky</strong> – právny základ: plnenie zmluvy alebo predzmluvné vzťahy (čl. 6 ods. 1 písm. b) GDPR)</li>
            <li><strong>Komunikácie s vami</strong> – právny základ: oprávnený záujem prevádzkovateľa (čl. 6 ods. 1 písm. f) GDPR)</li>
          </ul>
          <p className="mt-3">
            Poskytnutie údajov je dobrovoľné, avšak bez nich nie je možné vybaviť váš dopyt.
          </p>
        </Section>

        <Section title="4. Príjemcovia osobných údajov">
          <p>
            Vaše osobné údaje nie sú predávané, prenajímané ani inak poskytované tretím stranám na marketingové účely.
            Údaje z formulárov sú doručené výlučne na emailovú adresu prevádzkovateľa prostredníctvom servera webhostingu
            umiestneného v EÚ. Žiadne osobné údaje nie sú prenášané do tretích krajín mimo Európskeho hospodárskeho priestoru.
          </p>
        </Section>

        <Section title="5. Doba uchovávania">
          <p>
            Osobné údaje uchovávame len po dobu nevyhnutnú na vybavenie vášho dopytu alebo objednávky.
            Po vybavení dopytu sú údaje vymazané, resp. archivované v súlade s platnými právnymi predpismi
            (napr. zákon o účtovníctve, ak vznikne zmluvný vzťah).
          </p>
        </Section>

        <Section title="6. Vaše práva">
          <p>Ako dotknutá osoba máte právo:</p>
          <ul className="list-disc list-inside space-y-1 mt-2">
            <li><strong>Na prístup</strong> k svojim osobným údajom (čl. 15 GDPR)</li>
            <li><strong>Na opravu</strong> nesprávnych alebo neúplných údajov (čl. 16 GDPR)</li>
            <li><strong>Na vymazanie</strong> („právo na zabudnutie") (čl. 17 GDPR)</li>
            <li><strong>Na obmedzenie spracúvania</strong> (čl. 18 GDPR)</li>
            <li><strong>Na prenosnosť údajov</strong> (čl. 20 GDPR)</li>
            <li><strong>Namietať</strong> proti spracúvaniu na základe oprávneného záujmu (čl. 21 GDPR)</li>
            <li><strong>Odvolať súhlas</strong> kedykoľvek, ak je spracúvanie založené na súhlase (čl. 7 ods. 3 GDPR)</li>
          </ul>
          <p className="mt-3">
            Žiadosť o uplatnenie práv môžete zaslať na:{' '}
            <a href="mailto:petromin@petromin.sk" className="text-red-600 hover:underline">petromin@petromin.sk</a>.
          </p>
        </Section>

        <Section title="7. Právo podať sťažnosť">
          <p>
            Máte právo podať sťažnosť na Úrade na ochranu osobných údajov Slovenskej republiky:
          </p>
          <p className="mt-2">
            <strong>Úrad na ochranu osobných údajov SR</strong><br />
            Hraničná 12, 820 07 Bratislava<br />
            Tel.: +421 2 3231 3214<br />
            Web:{' '}
            <a
              href="https://dataprotection.gov.sk"
              target="_blank"
              rel="noopener noreferrer"
              className="text-red-600 hover:underline"
            >
              dataprotection.gov.sk
            </a>
          </p>
        </Section>

        <Section title="8. Súbory cookies">
          <p>
            Táto webová stránka nepoužíva sledovacie ani reklamné cookies. Používa len technicky nevyhnutné
            funkcie potrebné pre správne zobrazenie stránky.
          </p>
        </Section>

        <p className="text-gray-400 text-sm mt-12 border-t border-gray-200 pt-6">
          Posledná aktualizácia: apríl 2026
        </p>
      </div>

      <Footer />
      <ScrollRestoration />
    </div>
  );
}

export default Gdpr;
